import { pluralizeWithCount } from "@common/helpers/string";
import { BulkSelectionControl } from "@design-system/BulkSelectionControl/BulkSelectionControl";
import { Button } from "@design-system/Button/Button";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { CommandIslandTotal } from "@design-system/CommandIsland/CommandIslandTotal";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";
import { HStack } from "@design-system/HStack/HStack";
import { Shortcut } from "@design-system/Shortcut/Shortcut";
import { Tooltip } from "@design-system/Tooltip/Tooltip";

interface ScheduleListFooterProps {
    scheduleCount: number;
    selectedCount: number;
    onDeselect: () => void;
    onOpenBulkActions: () => void;
    isBulkActionPending: boolean;
}

/** The Schedules list's command island: the total, and the selection with its bulk actions. */
export const ScheduleListFooter = ({
    scheduleCount,
    selectedCount,
    onDeselect,
    onOpenBulkActions,
    isBulkActionPending,
}: Readonly<ScheduleListFooterProps>) => (
    <CommandIsland
        sticky
        className={commandIslandStyles.bulkActionsStickyFooter}
    >
        <HStack gap={8}>
            <CommandIslandTotal>
                {pluralizeWithCount("schedule", scheduleCount)}
            </CommandIslandTotal>
            {selectedCount > 0 && (
                <BulkSelectionControl
                    size="md"
                    selectedCount={selectedCount}
                    onClearSelection={onDeselect}
                />
            )}
        </HStack>
        {selectedCount > 0 && (
            <Tooltip content="Open bulk actions">
                <Button
                    variant="primary"
                    size="md"
                    rightIcon={
                        <span data-slot-box="">
                            <Shortcut keys="mod+k" />
                        </span>
                    }
                    onClick={onOpenBulkActions}
                    disabled={isBulkActionPending}
                >
                    Actions
                </Button>
            </Tooltip>
        )}
    </CommandIsland>
);
